//@flow
export type Location = {
  adminId: string,
  adminName: string,
  isExpanded: boolean,
  isChecked: boolean,
  isDisabled: boolean,
  subLocations: Location[],
  indeterminate?: boolean,
};

export type AdminAddress = {
  adminId: number,
  adminName: string,
};

export type Action =
  | {type: 'TOGGLE_EXPAND', indexes: number[]}
  | {type: 'TOGGLE_CHECK', indexes: number[]}
  | {type: 'SET_SUB_LOCATIONS', indexes: number[], subLocations: Location[]}
  | {type: 'CLEAR_ALL'}
  | {type: 'SET_INITIAL_LOCATIONS', subLocations: Location[]};

export const LOCATION_ACTIONS = {
  TOGGLE_EXPAND: 'TOGGLE_EXPAND',
  TOGGLE_CHECK: 'TOGGLE_CHECK',
  SET_SUB_LOCATIONS: 'SET_SUB_LOCATIONS',
  CLEAR_ALL: 'CLEAR_ALL',
  SET_INITIAL_LOCATIONS: 'SET_INITIAL_LOCATIONS',
};

export type DefaultSelectedAdmins = {
  [admin1Id: string]: {
    [admin2Id: string]: {
      [admin3Id: string]: boolean,
    },
  },
};
